import { useMemo } from 'react';
import { useBoardCoreData } from '../providers/BoardCoreDataProvider';
import { useUsageTracking } from '../usageTracking/hooks/useUsageTracking';
export const useLogger = () => {
  const {
    logger
  } = useBoardCoreData();
  const usageTracker = useUsageTracking();
  return useMemo(() => {
    return {
      log: event => {
        if (event.key === 'columnCollapseChange') {
          usageTracker.trackColumnCollapseChange(event.metadata.collapsed);
        } else if (event.key === 'columnChanged') {
          usageTracker.trackColumnChange(event.metadata.objectId, event.metadata.nextStageId);
        } else if (event.key === 'navigationToRecordsPage') {
          usageTracker.trackNavigationToRecordsPage(event.metadata.objectId);
        } else if (event.key === 'previewSideBarTriggered') {
          usageTracker.trackPreviewSideBarTriggered(event.metadata.objectId);
        } else if (event.key.startsWith('bulk')) {
          usageTracker.trackBoardBulkAction(event.key);
        }
        logger === null || logger === void 0 || logger.log(event);
      }
    };
  }, [logger, usageTracker]);
};